import { post } from '@core/api/baseApi';

type Request = {
  start: Date;
  end: Date;
  sortOrder: string; // 'asc' | 'desc'
};

const getStudiesStatisticsXLSX = ({ start, end, sortOrder }: Request): Promise<Blob> =>
  post(
    'studies/statistics/studies/xlsx',
    {
      start,
      end,
      sortOrder,
      timeZoneOffsetInMinutes: start.getTimezoneOffset() * -1,
    },
    {
      responseType: 'blob',
    },
  );

export default getStudiesStatisticsXLSX;
